// extracted by mini-css-extract-plugin
export default {"alert":"CapsulesFetchErrorAlert_alert__2P7AM"};